import React from 'react'
import styled from 'styled-components'

// icons
import { Check } from '@styled-icons/feather'
import { Settings } from 'styled-icons/ionicons-outline'

// utils
import th from 'utils/themeHelper'

const ActionItem = styled.div`
  margin-right: 10px;

  &:last-of-type {
    margin-right: 0;
  }
`

const OverWrapper = styled.div`
  background: ${props => (props.isSelected ? '#379b7533' : 'white')};
  border-color: ${th('borders.medium')};
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  display: block;
  padding: ${props => props.padding || '10px 0'};
  position: relative;
`

const CardButton = styled.button`
  background: white;
  border-color: ${th('backgrounds.mid')};
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  color: ${th('text.dark')};
  margin: 0;
  padding: 8px 12px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;

  & > svg {
    width: 15px;
    margin-right: 10px;
  }
`

const Info = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 15px 10px;
`

const InfoFieldLabel = styled.div`
  font-family: ${th('fonts.bold')};
  margin-right: 10px;
`

const InfoFieldValue = styled.div`
  font-family: ${th('fonts.regular')};
  margin-left: 30px;
`

const InfoFieldIcon = styled.div`
  margin-right: 10px;

  & > svg {
    height: 20px;
  }
`

const InfoGroup = styled.div`
  min-width: 30%;
`

const InfoGroupRow = styled.div`
  color: ${th('text.mid')};
`

const InfoGroupRowInner = styled.div`
  display: flex;
  word-break: break-word;
`

const DashTrainingSelectionCard = ({ bulkSelectedIds, id, name, toggleSingleCheckbox }) => {
  const isSelected = bulkSelectedIds.includes(id)

  return (
    <OverWrapper isSelected={isSelected}>
      <Info>
        <InfoGroupRow>
          <InfoGroupRowInner>
            <InfoFieldLabel>Name</InfoFieldLabel>
          </InfoGroupRowInner>

          <InfoGroupRowInner>
            <div>{name}</div>
          </InfoGroupRowInner>
        </InfoGroupRow>

        <ActionItem>
          <CardButton onClick={() => toggleSingleCheckbox(id)}>
            {isSelected ? <Check /> : <Settings />}
            <span>{isSelected ? 'Selected' : 'Click to select'}</span>
          </CardButton>
        </ActionItem>
      </Info>
    </OverWrapper>
  )
}

export default DashTrainingSelectionCard
